
let triggerSource = '';

$(document).on('click','.swiper-pagination', function() {
  triggerSource = 'Bar switch';
});

$(document).on('click', '.swiper-button-next', function() {
  triggerSource = 'Right switch';
  
});
$(document).on('click', '.swiper-button-prev', function() {
  triggerSource = 'Left switch';
});

class QuantityInputData {
  constructor () {
    this.type = '';
  }
  
  plus () {
    this.type = 'plus'
  }
  
  minus () {
    this.type = 'minus'
  }
  
  clear () {
    this.type = ''
  }
  
  isPlus () {
    return this.type === 'plus'
  }
  
  isMinus () {
    return this.type === 'minus'
  }
}


class GoogleAnalyzePoint {
  
  constructor () {
    this.task = [];
    this.currencyUnitRatios = {
      'AED': 100,
      'AFN': 100,
      'ALL': 100,
      'AMD': 100,
      'ANG': 100,
      'AOA': 100,
      'ARS': 100,
      'AUD': 100,
      'AWG': 100,
      'AZN': 100,
      'BAM': 100,
      'BBD': 100,
      'BDT': 100,
      'BGN': 100,
      'BHD': 1000,
      'BIF': 1,
      'BMD': 100,
      'BND': 100,
      'BOB': 100,
      'BRL': 100,
      'BSD': 100,
      'BTN': 100,
      'BWP': 100,
      'BYN': 100,
      'BZD': 100,
      'CAD': 100,
      'CDF': 1,
      'CHF': 100,
      'CLP': 100,
      'CNY': 100,
      'COP': 100,
      'CRC': 100,
      'CUP': 100,
      'CVE': 100,
      'CZK': 100,
      'DJF': 1,
      'DKK': 100,
      'DOP': 100,
      'DZD': 100,
      'EGP': 100,
      'ERN': 100,
      'ETB': 100,
      'EUR': 100,
      'FJD': 100,
      'FKP': 100,
      'FOK': 100,
      'GBP': 100,
      'GEL': 100,
      'GGP': 100,
      'GHS': 100,
      'GIP': 100,
      'GMD': 100,
      'GNF': 1,
      'GTQ': 100,
      'GYD': 100,
      'HKD': 100,
      'HNL': 100,
      'HRK': 100,
      'HTG': 100,
      'HUF': 100,
      'IDR': 100,
      'ILS': 100,
      'IMP': 100,
      'INR': 100,
      'IQD': 1000,
      'IRR': 100,
      'ISK': 100,
      'JEP': 100,
      'JMD': 100,
      'JOD': 100,
      'JPY': 1,
      'KES': 100,
      'KGS': 100,
      'KHR': 100,
      'KID': 100,
      'KMF': 1,
      'KRW': 1,
      'KWD': 1000,
      'KYD': 100,
      'KZT': 100,
      'LAK': 100,
      'LBP': 100,
      'LKR': 100,
      'LRD': 100,
      'LSL': 100,
      'LYD': 1000,
      'MAD': 100,
      'MDL': 100,
      'MGA': 100,
      'MKD': 100,
      'MMK': 100,
      'MNT': 100,
      'MOP': 100,
      'MRU': 5,
      'MUR': 100,
      'MVR': 100,
      'MWK': 100,
      'MXN': 100,
      'MYR': 100,
      'MZN': 100,
      'NAD': 100,
      'NGN': 100,
      'NIO': 100,
      'NOK': 100,
      'NPR': 100,
      'NZD': 100,
      'OMR': 1000,
      'PAB': 100,
      'PEN': 100,
      'PGK': 100,
      'PHP': 100,
      'PKR': 100,
      'PLN': 100,
      'PYG': 100,
      'QAR': 100,
      'RON': 100,
      'RSD': 100,
      'RUB': 100,
      'RWF': 1,
      'SAR': 100,
      'SBD': 100,
      'SCR': 100,
      'SDG': 100,
      'SEK': 100,
      'SGD': 100,
      'SHP': 100,
      'SLL': 100,
      'SOS': 100,
      'SRD': 100,
      'SSP': 100,
      'STN': 100,
      'SYP': 100,
      'SZL': 100,
      'THB': 100,
      'TJS': 100,
      'TMT': 100,
      'TND': 1000,
      'TOP': 100,
      'TRY': 100,
      'TTD': 100,
      'TVD': 100,
      'TWD': 100,
      'TZS': 100,
      'UAH': 100,
      'UGX': 100,
      'USD': 100,
      'UYU': 100,
      'UZS': 100,
      'VES': 100,
      'VND': 100,
      'VUV': 1,
      'WST': 100,
      'XAF': 1,
      'XCD': 100,
      'XOF': 1,
      'XPF': 1,
      'YER': 100,
      'ZAR': 100,
      'ZMW': 100,
      'ZWL': 100
    };
  }
  
  pageLoadInitEvent () {
    for (let i = 0; i < this.task.length; i++) {
      const fn = this.task[i];
      fn();
    }    
  }
  
  
  register (fn) {
    this.task.push(fn);
  }
  
  ribbon (content = '', buttonName = '') {
    this.execute(
      "top_ribbon",
      {
        "notification_content": content,
        "button_name": buttonName,
        // "type": type
      }
    );
  }
  
  execute (eventName ,eventParam, eventType = 'ga4Event') {
    // console.log(eventName, eventParam);
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event": eventType,
      "event_name": eventName,
      "event_parameters": eventParam
    });
  }
  
  topFirstNav (name) {
    this.execute(
      "top_first_navigation",
      {
        "first_nav": name
      }
    );
  }
  
  topSecondNav (firstNav, secondNav, positon) {
    this.execute(
      "top_second_navigation",
      {
        "first_nav": firstNav,
        "second_nav": secondNav, 
        "position": positon
      }
    );
  }
  
  topFunction (buttonName, pageName){
    this.execute(
      "top_function",
      {
        "page_name": pageName,
        "button_name": buttonName
      }
    );
  }
  
  modelComparison (buttonName, moduleName='Top Navigation') {
    this.execute(
      "model_comparison",
      {
        "list_name": 'None',
        "module_name": moduleName,
        "button_name": buttonName
      }
    );
  }
  
  bottomNav (buttonName, listName) {
    this.execute(
      "bottom_navigation",
      {
        "list_name": listName,
        "navigation_name": buttonName
      }
    );
  }
  
  bottomSocail (buttomName) {
    this.execute(
      "tenways_social",
      {
        "button_name": buttomName
      }
    );
  }
  
  bottomSubscrible (buttonName, tag) {
    this.execute(
      "subscription",
      {
        "module_name": 'Bottom Navigation', // Bottom Navigation/ Popup
        // "status": '', // Success/Fail
        "button_name": buttonName,
        "tag": tag // Agree/Disagree/None
      }
    );
  }
  
  bottomCountry (buttonName, content) {
    this.execute(
      "select_country",
      {
        "button_name": buttonName,
        "content": content
      }
    );
  }
  
  formattedPrice (priceInMinorUnits, currency) {
    let unitRatio = this.currencyUnitRatios[currency] || 100;
    const priceInCurrency = priceInMinorUnits / unitRatio;
    return priceInCurrency % 1 === 0 ? +priceInCurrency.toFixed(0) : +priceInCurrency.toFixed(2)
  }
  
  viewCart () {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let items = [];
      let currency = cart.currency || 'EUR';
      
      cart.items.forEach((item, index) => {
        items.push(
          this.filterObject({
            "item_id": item.id,
            "item_name": item.title,
            "coupon": "None",
            "discount": item.line_level_total_discount ? this.formattedPrice(item.line_level_total_discount, currency) : 'None',
            "index": index + 1,
            "item_list_id": "None",
            "item_list_name": "None",
            "location_id": "None",
            "itemCategory": "None",
            "itemCategory2": "None",
            "itemCategory3": "None",
            "itemCategory4": "None",
            "itemCategory5": "None",
            "itemVariant": item.variant_title || 'None',
            "item_brand": item.vendor,
            "price": this.formattedPrice(item.line_price, currency),
            "quantity": item.quantity,
            "currency": cart.currency,
            "creative_name": "None",
            "creative_slot": "None",
            "promotion_id": "None",
            "promotion_name": "None"
          })
        )
      });
      
      this.execute(
        "view_cart",
        {
          "currency": cart.currency,
          "value": this.formattedPrice(cart.total_price, currency),
          "items": items
        }
      )
    })
  }
  
  /**
   * operate cart item
   */
  operateCartItem (product, line, quantity, oldQuantity) {
    let method ='Amount';
    if (quantityInputData.type !== '') {
      method = 'Add'
    }
    if (quantityInputData.isPlus() || parseInt(oldQuantity, 10) < parseInt(quantity, 10)) {
      let items = [];
      let total = 0;
      
      fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let carItems = cart.items || [];
        product.items_added.forEach((item) => {
          for( let i = 0; i < carItems.length; i++) {
            const cartItem = carItems[i];
            if (cartItem['id'] === item['variant_id']) {
              let discount = cartItem.price - cartItem.discounted_price;
              let discountedValue = this.formattedPrice(discount, Shopify.currency.active);
              items.push(
                this.filterObject({
                  "item_id": item.variant_id,
                  "item_name": item.title,
                  "coupon": "None",
                  "discount": discountedValue !== 0 ? discountedValue : 'None',
                  "index": line,
                  "item_list_id": "None",
                  "item_list_name": "None",
                  "location_id": "None",
                  "itemCategory": "None",
                  "itemCategory2": "None",
                  "itemCategory3": "None",
                  "itemCategory4": "None",
                  "itemCategory5": "None",
                  "itemVariant": item.variant_title,
                  "item_brand": item.vendor,
                  "price": this.formattedPrice(cartItem.final_price, Shopify.currency.active),
                  "quantity": item.quantity,
                  "currency": Shopify.currency.active,
                  "creative_name": "None",
                  "creative_slot": "None",
                  "promotion_id": "None",
                  "promotion_name": "None"
                })
              )
              total = total + this.formattedPrice(cartItem.final_price * item.quantity, Shopify.currency.active);
              break;
            }
          }
        })
        
        this.execute(
          "add_to_cart",
          {
            "currency": Shopify.currency.active,
            "value": total,
            "button_name": method === 'Add' ? "Add Icon": "Amount Edit",
            "method": method,
            "items": items
          }
        )
      })
    }
    
    quantityInputData.clear();
  }
  
  filterObject(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => value !== 'None' && value !== undefined && value !== null)
    );
  }
  
  selectItem (buttonName, index, product, method = 'Title', moduleName = 'Cart', itemListName = 'None') {

    let url = product.url;
    
    if (!/http/.test(url)) {
      url = `${location.origin}${product.url}`
    }
    
    this.execute(
      "select_item",
      this.filterObject({
        "button_name": buttonName,
        "product_name": product.title,
        "module_name": moduleName,
        "method": method,
        "jump_to_url": url,
        "items": [
          this.filterObject({
            "item_id": product.id,
            "item_name": product.title,
            "item_list_name": itemListName,
            "discount": product.total_discount ? this.formattedPrice(product.total_discount, Shopify.currency.active) : 'None',
            "index": index,
            "itemVariant": product.variant_title || 'None',
            "item_brand": product.vendor,
            "price": this.formattedPrice(product.final_price || product.price, Shopify.currency.active),
            "quantity": product.quantity || 1,
            "currency": Shopify.currency.active
          })
        ]
      })
    );
  }
  
  beginCheckout (buttonName) {
    
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let items = [];
      cart.items.forEach((item, index) => {
        items.push(
          this.filterObject({
            "item_id": item.id,
            "item_name": item.title,
            "coupon": "None",
            "discount": this.formattedPrice(item.line_level_total_discount, cart.currency),
            "index": index + 1,
            "item_list_id": "None",
            "item_list_name": "None",
            "location_id": "None",
            "itemCategory": "None",
            "itemCategory2": "None",
            "itemCategory3": "None",
            "itemCategory4": "None",
            "itemCategory5": "None",
            "itemVariant": item.variant_title || 'None',
            "item_brand": item.vendor,
            "price": this.formattedPrice(item.line_price, cart.currency),
            "quantity": item.quantity,
            "currency": cart.currency,
            "creative_name": "None",
            "creative_slot": "None",
            "promotion_id": "None",
            "promotion_name": "None"
          })
        )
      });
      
      this.execute(
        "begin_checkout",
        {
          "currency": cart.currency,
          "value": this.formattedPrice(cart.total_price, cart.currency),
          "button_name": buttonName,
          "items": items
        }
      )
    })
  }
  
  bannerView (bannerName, postion, listName = 'None') {
    this.execute(
      "view_banner",
      this.filterObject({
        "banner_name": bannerName,
        "position": postion,
        "list_name": listName
      })
    )
  }
  
  selectBanner (bannerName, postion, buttonName, listName='None') {
    this.execute(
      "select_banner",
      {
        "banner_name": bannerName,
        "position": postion,
        "button_name": buttonName,
        "list_name": listName
      }
    )
  }
  
  getSupport (buttonName) {
    this.execute(
      "get_support",
      {
        "button_name": buttonName
      }
    )
  }
  
  login (method = 'Email') {
    this.execute(
      "login",
      {
        method
      }
    )
  }
  
  signUp (tag, buttonName = 'None', method='Email') {
    this.execute(
      "sign_up",
      this.filterObject({
        method,
        tag,
        buttonName
      })
    )
  }
  
  viewItem (buttonName, productHandle) {
    fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      const items = [
        {
          "item_id": product.id,
          "item_name": product.title,
          "item_brand":"Tenways",
          "price": this.formattedPrice(product.price, Shopify.currency.active),
          "index": 1,
          "quantity": 1
        }
      ]
      
      this.execute(
        "view_item",
        {
          "currency": Shopify.currency.active,
          "value": this.formattedPrice(product.price, Shopify.currency.active),
          "button_name": buttonName,
          "items": items
        }
      )
    })
  }
  
  // index product list show event
  viewItemList (products, moduleName, listItemName) {
    if (!Array.isArray(products)) {
      products = [products];
    }
    let items = [];
    
    products.forEach((product, index) => {
      items.push(
        this.filterObject({
          "item_id": product.id,
          "item_name": product.title,
          "coupon": "None",
          "discount": product.line_level_total_discount ? this.formattedPrice(product.line_level_total_discount, Shopify.currency.active) : 'None',
          "index": index + 1,
          "item_list_id": "None",
          "item_list_name": listItemName,
          "location_id": "None",
          "itemCategory": "None",
          "itemCategory2": "None",
          "itemCategory3": "None",
          "itemCategory4": "None",
          "itemCategory5": "None",
          "itemVariant": product.variant_title,
          "item_brand": product.vendor,
          "price": this.formattedPrice(product.price, Shopify.currency.active),
          "quantity": product.quantity || 1,
          "currency": Shopify.currency.active,
          "creative_name": "None",
          "creative_slot": "None",
          "promotion_id": "None",
          "promotion_name": "None"
        })
      )
    })
    
    this.execute(
      "view_item_list",
      {
        "module_name": moduleName,
        "items": items
      }
    )
  }
  
  switchBanner (position, listName) {
    let method = triggerSource || 'Auto switch';
    this.execute(
      "switch_banner",
      {
        "position": position,
        "method": method,
        "list_name": listName
      }
    )
    triggerSource = '';
  }
  
  switchModel (model) {
    this.execute(
      "switch_model",
      {
        "model": model
      }
    )
  }
  
  addToCart (reponse) {
    let total = 0;
    let items = [];
    
    // get cart item
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let carItems = cart.items || [];
      
      reponse.forEach((item) => {
        
        for( let i = 0; i < carItems.length; i++) {
          const cartItem = carItems[i];
          if (cartItem['id'] === item['id']) {
            let discount = cartItem.price - cartItem.discounted_price;
            let discountedValue = this.formattedPrice(discount, Shopify.currency.active);
            items.push(
              this.filterObject({
                "item_id": item.id,
                "item_name": item.title,
                "coupon": "None",
                "discount": discountedValue !== 0 ? discountedValue : 'None',
                "index": i + 1,
                "item_list_id": "None",
                "item_list_name": "None",
                "location_id": "None",
                "itemCategory": "None",
                "itemCategory2": "None",
                "itemCategory3": "None",
                "itemCategory4": "None",
                "itemCategory5": "None",
                "itemVariant": item.variant_title,
                "item_brand": item.vendor,
                "price": this.formattedPrice(cartItem.final_price, Shopify.currency.active),
                "quantity": 1,
                "currency": Shopify.currency.active,
                "creative_name": "None",
                "creative_slot": "None",
                "promotion_id": "None",
                "promotion_name": "None"
              })
            )
            
            total += this.formattedPrice(cartItem.final_price, Shopify.currency.active);
            break;
          }
        }
      });
      
      this.execute(
        "add_to_cart",
        {
          "currency": Shopify.currency.active,
          "value": total,
          "button_name":"add to Cart",
          "method":"Button",
          "items": items
        }
      )
    });
  }
  
 
  viewFaq (content, position, listName) {
    this.execute(
      "view_faq",
      {
        "content": content,
        "position": position,
        "list_name": listName
      }
    )
  }
  
  faqUnfold (buttonName, listName) {
    this.execute(
      "faq_unfold",
      {
        "button_name": buttonName,
        "list_name": listName
      }
    )
  }
  
  supportMoreService (buttonName, listName) {
    this.execute(
      "support_more_service",
      {
        "button_name": buttonName,
        "list_name": listName
      }
    )
  }
  
  productDetail (tab, buttonName) {
    this.execute(
      "product_details",
      {
        "tab": tab,
        "button_name": buttonName
      }
    )
  }
  
  selectLakaInsurance (itemName, partner='laka', variant="1") {
    this.execute(
      "addInsurance",
      {
        "item": itemName,
        "insurance_partner": partner,
        "insurance_variant": variant
      }
    )
  }
  
  cancelLakaInsurance (itemName, partner='laka', variant="1") {
    this.execute(
      "cancelInsurance",
      {
        "item": itemName,
        "insurance_partner": partner,
        "insurance_variant": variant
      }
    )
  }
}

let quantityInputData = new QuantityInputData();
const googleAnayzePoint = window.googleAnayzePoint = new GoogleAnalyzePoint();

$(document).ready(function () {
  // insurance option
  $('.google-insurance-option').on('insurance-selected', function () {
    const itemName = $(this).data("google-key-item-name");
    googleAnayzePoint.selectLakaInsurance(itemName);
  })
  
  $('.google-insurance-option').on('insurance-cancled', function () {
    const itemName = $(this).data("google-key-item-name");
    googleAnayzePoint.cancelLakaInsurance(itemName);
  })
  
  // top nav event click
  $(".googe-first-nav").on('click', function () {
    googleAnayzePoint.topFirstNav($(this).data("google-key"));
  })
  
  // second nav event click
  $(".googe-second-nav").on('click', function () {
    googleAnayzePoint.topSecondNav($(this).data("google-key-first-nav"), $(this).data("google-key-second-nav"), $(this).data("google-key-postion"));
  })
  
  // top function event click
  $(".googe-top-function").on('click', function () {
    const pageName = $(this).data("google-key-page-name");
    googleAnayzePoint.topFunction($(this).data("google-key-fun-name"), pageName);
  })
  
  $(".googe-nav-order-now").on('click', function () {
    if (!document.querySelector('modal-product').classList.contains("modal-hidden")) {
      const buttonName = $(this).data("google-key-button-name");
      const productHandle = $(this).data("google-key-product-handle");
      googleAnayzePoint.viewItem(buttonName, productHandle);
    }
  })
  
  // top modal comparison event click
  $(".googe-top-modal-comparison").on('click', function () {
    const moduleName = $(this).data('google-key-module-name') || 'Top Navigation'
    googleAnayzePoint.modelComparison($(this).data("google-key-button-name"), moduleName);
  })
  
  // bottom nav link event click
  $(".googe-bottom-nav").on('click', function () {
    googleAnayzePoint.bottomNav($(this).data("google-key-button-name"), $(this).data("google-key-list-name"));
  })
  
  
  $(".googe-bottom-social").on('click', function () {
    googleAnayzePoint.bottomSocail($(this).data("google-key-button-name"));
  })
  
  $(".googe-bottom-subscrible").on('click', function () {
    let tag = document.querySelector("#checkbox_policy").checked === true ? 'Agree': 'Disagree';
    googleAnayzePoint.bottomSubscrible($(this).data("google-key-button-name"), tag);
  })
  
  $(".google-bottom-country").on('click', function () {
    googleAnayzePoint.bottomCountry($(this).data("google-key-button-name"), 'Country/region');
  })
  
  $(".google-bottom-language").on('click', function () {
    googleAnayzePoint.bottomCountry($(this).data("google-key-button-name"), 'Language');
  })
  
  $(".google-cart-view").on('click', function () {
    googleAnayzePoint.viewCart($(this).data("google-key-button-name"), 'Language');
  })
  
  $(document).on('click', '.google-select-item-cart-title', function () {
    const data = $(this).data('google-key-product');
    data.url = $(this).data('google-key-product-url');
    let moduleName = $(this).data('google-key-module-name') || 'Cart';
    googleAnayzePoint.selectItem($(this).data("google-key-button-name"), $(this).data('google-key-index'), data, 'Title', moduleName);
  })
  
  $(document).on('click', '.google-select-item-cart-image', function () {
    const data = $(this).data('google-key-product');
    data.url = $(this).data('google-key-product-url');
    let moduleName = $(this).data('google-key-module-name') || 'Cart';
    let itemListName = $(this).data('google-key-item-list-name') || 'None';
    
    googleAnayzePoint.selectItem('Img', $(this).data('google-key-index'), data, 'Img', moduleName, itemListName);
  })
  
  $(document).on('click', '.google-select-item-cart-button', function () {
    const data = $(this).data('google-key-product');
    data.url = $(this).data('google-key-product-url');
    let moduleName = $(this).data('google-key-module-name') || 'Cart';
    let buttomName = $(this).data('google-key-button-name') || 'button';
    let itemListName = $(this).data('google-key-item-list-name') || 'None';
    
    googleAnayzePoint.selectItem(buttomName, $(this).data('google-key-index'), data, 'button', moduleName, itemListName);
  })
  
  $("cart-drawer").on('click', '.google-begin-checkout', function () {
    googleAnayzePoint.beginCheckout($(this).data('google-key-button-name'));
  })
  
  $(document).on('click', '.google-select-item-comparison-button', function () {
    const key = $(this).data('index');
    const price = $(`#price_value_${key}`).data('origin_price');
    const title = $(`#title_value_${key}`).data('title');
    const data = {
      "item_id": "None",
      "title": title,
      "vendor": "Tenways",
      "price": price,
      "quantity": 1,
    };
    
    data.url = `${location.origin}${$(this).attr('href')}`;
    let moduleName = $(this).data('google-key-module-name') || 'Cart';
    
    googleAnayzePoint.selectItem($(this).data("google-key-button-name"), 1, data, 'Button', moduleName);
  })
  
  $('.google-banner-select').on('click', function () {
    googleAnayzePoint.selectBanner(
      $(this).data('google-key-banner-name'),
      $(this).data('google-key-banner-index'),
      $(this).data('google-key-button-name'),
      $(this).data('google-key-list-name')
    );
  })
  
  $('.google-get-support').on('click', function () {
    googleAnayzePoint.getSupport($(this).data('google-key-button-name'));
  })
  
  
  $('.google-switch-model').on('click', function () {
    googleAnayzePoint.switchModel($(this).data('google-key-model-name'));
  })
  
  $('.google-tab-product-detail').on('click', function () {
    const index = $(this).data('google-key-index');
    const tabName = $($('.google-proudct-tab')[index - 3]).data('google-key-tab');
    
    googleAnayzePoint.productDetail(tabName,$(this).data('google-key-button-name'));
  })
  
  
  $('.google-faq-view').on('click', function () {
    const content = $(this).data('google-key-faq-content');
    const position = $(this).data('google-key-faq-position');
    const listName = $(this).data('google-key-list-name');
    
    googleAnayzePoint.viewFaq(content, position, listName);
  })
  
  $('.google-faq-unfold').on('click', function () {
    const buttonName = $(this).data('google-key-button-name');
    const listName = $(this).data('google-key-list-name');
    
    googleAnayzePoint.faqUnfold(buttonName, listName);
  })
  
  $('.google-support-more').on('click', function () {
    const buttonName = $(this).data('google-key-button-name');
    const listName = $(this).data('google-key-list-name');
    
    googleAnayzePoint.supportMoreService(buttonName, listName);
  })
  
  $('.google-login').on('click', function () {
    googleAnayzePoint.login();
  })
  
  $('.google-sign-up').on('click', function () {
    let tag = 'None'
    const node = $('#accepts_marketing-input');
    
    if (node.length) {
      tag = node[0].checked ? 'Agree' : 'Disagree';
    }
    const buttonName = $(this).data('google-key-button-name') || 'None';
    
    googleAnayzePoint.signUp(tag, buttonName);
  })
  
  // product list event on pageload
  googleAnayzePoint.register(function () {
    const targetElements = document.querySelectorAll('.google-product-view-list');
    const hasIntersected = new Set();
    
    function handleIntersection(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasIntersected.has(entry.target)) {
          hasIntersected.add(entry.target);
          observer.unobserve(entry.target);
          viewInPortHandler(entry.target);
        }
      });
    }
    
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    });
    
    targetElements.forEach(element => observer.observe(element));
    
    function viewInPortHandler (target) {
      const moduleName = $(target).data('google-key-module-name') || 'Product List';
      const listItemName = $(target).data('google-key-item-list-name') || 'None';
      
      const listProducts = target.querySelectorAll('[type="application/json"][name="product-info"]');
      
      const listProductsJson = [];
      listProducts.forEach(product => {
        listProductsJson.push(JSON.parse(product.textContent));
      })
      
      googleAnayzePoint.viewItemList(listProductsJson, moduleName, listItemName);
    }
    
    const mutationObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.classList && node.classList.contains('google-product-view-list')) {
            observer.observe(node);
          }
        });
      });
    });
    
    const cartDrawer = document.querySelector('cart-drawer');
    
    mutationObserver.observe(cartDrawer, { childList: true, subtree: true });
  });
  
  googleAnayzePoint.pageLoadInitEvent();
});
